// extracted by mini-css-extract-plugin
export default {"button":"Jb-gfDRUHDsS3GK4-9MKJA==","svg":"jhpOGaZi1+M-m5HmebD60Q=="};